// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__39pds","options":"AnswerScale_options__3WfhU","selected":"AnswerScale_selected__X1vmC"};